


 export const PlayerData =[
   {
    id:1,
    country:"india",
    players:[
        {
            id:1,
            name:"Washington Sundar",
            imgsrc:'https://i.ibb.co/c3kzvPk/27.png'
        },
        {
            id:2,
            name:"H. Vihari",
            imgsrc:'https://i.ibb.co/DKhzz38/26.png'
        },
        {
            id:3,
            name:"Sreyah Iyer",
            imgsrc:'https://i.ibb.co/LkssB3h/25.png'
        },
        {
            id:4,
            name:"Deepak Chahar",
            imgsrc:'https://i.ibb.co/wWK9DNj/23.png'
        },
        {
            id:5,
            name:"Shardul Thakur",
            imgsrc:'https://i.ibb.co/9hyNL4f/22.png'
        },{
            id:6,
            name:"N. Saini",
            imgsrc:'https://i.ibb.co/BrMwRqb/21.png'
        },{
            id:7,
            name:"Kedar Jadav",
            imgsrc:'https://i.ibb.co/mCYjZxn/20.png'
        },{
            id:8,
            name:"M. Agarwal",
            imgsrc:'https://i.ibb.co/MDy1TCC/19.png'
        },{
            id:9,
            name:"Hardik Pandya",
            imgsrc:'https://i.ibb.co/y53SzX3/18.png'
        },{
            id:10,
            name:"Y. Chahal",
            imgsrc:'https://i.ibb.co/wCSm0PJ/17.png'
        },{
            id:11,
            name:"Umesh Yadav",
            imgsrc:'https://i.ibb.co/pKNj7hY/16.png'
        },{
            id:12,
            name:"W. Saha",
            imgsrc:'https://i.ibb.co/SNPcCWW/15.png'
        },{
            id:13,
            name:"Rishav Pant",
            imgsrc:'https://i.ibb.co/3c7K7RQ/14.png'
        },{
            id:14,
            name:"KL Rahul",
            imgsrc:'https://i.ibb.co/vXtqBwF/13.png'
        },{
            id:15,
            name:"J. Bumrah",
            imgsrc:'https://i.ibb.co/2nSsRCy/12.png'
        },{
            id:16,
            name:"Kuldeep Yadav",
            imgsrc:'https://i.ibb.co/cXn6j27/11.png'
        },{
            id:17,
            name:"Virat Kohli",
            imgsrc:'https://i.ibb.co/8YYPNDp/10.png'
        },{
            id:18,
            name:"Rabindra jadeja",
            imgsrc:'https://i.ibb.co/dk2SfYW/9.png'
        },{
            id:19,
            name:"R. Ashwin",
            imgsrc:'https://i.ibb.co/XVSLRS2/8.png'
        },{
            id:20,
            name:"C. Pujara",
            imgsrc:'https://i.ibb.co/RDN0Khk/7.png'
        },{
            id:21,
            name:"A. rahane",
            imgsrc:'https://i.ibb.co/qMvZcf1/6.png'
        },{
            id:22,
            name:"B. Kumar",
            imgsrc:'https://i.ibb.co/9cg6jBs/5.png'
        },{
            id:23,
            name:"Rohit Sharma",
            imgsrc:'https://i.ibb.co/gVLwQ9p/4.png'
        },{
            id:24,
            name:"Md. Shami",
            imgsrc:'https://i.ibb.co/q0bt26q/3.png'
        },{
            id:25,
            name:"Ishant Sharma",
            imgsrc:'https://i.ibb.co/khMg3yY/1.png'
        },{
            id:26,
            name:"Sikhar Dhawan",
            imgsrc:'https://i.ibb.co/FgFd2C5/2.png'
        }
    ]
   },
   {
    id:2,
    country:"Australia",
    players:[
        {
            id:1,
            name:"Steve Smith",
            imgsrc:'https://i.ibb.co/xhW3zb9/1.png'
        },
        {
            id:2,
            name:"David Warner",
            imgsrc:'https://i.ibb.co/LSS2MJz/2.png'
        },
        {
            id:3,
            name:"Maxwell",
            imgsrc:'https://i.ibb.co/7CbZKf2/3.png'
        },
        {
            id:4,
            name:"Pat Cummins",
            imgsrc:'https://i.ibb.co/1RV5NNW/4.png'
        },
        {
            id:5,
            name:"Aron Finch",
            imgsrc:'https://i.ibb.co/JR4c8Py/5.png'
        }
    ]
   },
   {
    id:3,
    country:"England",
    players:[
        {
            id:1,
            name:"Joe Root",
            imgsrc:'https://i.ibb.co/gDqn27x/1.png'
        },
        {
            id:2,
            name:"Ben Stock",
            imgsrc:'https://i.ibb.co/n8n8b05/2.png'
        },
        {
            id:3,
            name:"Eion Morgan",
            imgsrc:'https://i.ibb.co/n7g7qMw/3.png'
        },
        {
            id:4,
            name:"Buttler",
            imgsrc:'https://i.ibb.co/QY3vX5m/4.png'
        }
    ]
   }


]